/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file UpdateFeed component
 * @author Dustin Gage
 */

import React, { memo } from "react";
import { useSettings } from "../../api/use-settings";
import { FeedItem } from "./FeedItem";
import { StringResource } from "../StringResource";

interface IProps {}

export const UpdateFeed = memo((props: IProps) => {
	const {} = props;
	const { resourceFeed } = useSettings();

	const hasResources = resourceFeed?.length > 0;

	return (
		<>
			{hasResources ? (
				<div id="ResourcesCard" className="card card-rounded shadow">
					<div className="card-body">
						<div className="card-title font-weight-bold text-center">
							<StringResource token={StringResources.covidtriage.LandingPageFeedHeading} />
						</div>
						<div className="card-items">
							{resourceFeed.map((resource, index) => (
								<FeedItem key={index} resource={resource} />
							))}
						</div>
					</div>
				</div>
			) : (
				void 0
			)}
		</>
	);
});
